import IconError from '@apollo/icons/default/IconError.svg';
import IconUnavailable from '@apollo/icons/default/IconUnavailable.svg';
import IconWarning from '@apollo/icons/default/IconWarning.svg';
import classnames from 'classnames';
import React from 'react';

import { assertUnreachable } from 'src/lib/assertUnreachable';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { LintDiagnosticLevel } from 'src/lib/graphqlTypes/types';

/**
 * TODO(rebrand): remove the `important`s here once icon colors can be overridden within buttons
 */

export const SeverityLevelIcon = ({
  severity,
  className,
}: {
  severity: GraphQLTypes.LintDiagnosticLevel;
  className?: string;
}) => {
  switch (severity) {
    case LintDiagnosticLevel.ERROR:
      return (
        <IconError className={classnames(className, '!text-icon-error')} />
      );
    case LintDiagnosticLevel.WARNING:
      return (
        <IconWarning className={classnames(className, '!text-icon-warning')} />
      );
    case LintDiagnosticLevel.IGNORED:
      return (
        <IconUnavailable
          className={classnames(className, '!text-icon-secondary')}
        />
      );
    default:
      return assertUnreachable(severity);
  }
};
